export const environment = {
  production: true,
  version: '6b82f9bbfc',
  site_version: 'SITE_VERSION'
};
